<script setup>
import IframeLoader from 'shared/components/IframeLoader.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useMapGetter } from 'dashboard/composables/store';

defineProps({
  url: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['back', 'insert']);

const isRTL = useMapGetter('accounts/isRTL');

const onBack = e => {
  e.stopPropagation();
  emit('back');
};

const onInsert = e => {
  e.stopPropagation();
  emit('insert');
};
</script>

<template>
  <div class="flex h-full w-full flex-1 flex-col overflow-hidden">
    <div class="py-1">
      <Button
        link
        xs
        :label="$t('HELP_CENTER.ARTICLE_SEARCH.BACK_RESULTS')"
        icon="i-lucide-chevron-left"
        class="!rounded-lg !text-auth-muted hover:!bg-auth-soft hover:!text-auth-text dark:!text-auth-muted-dark dark:hover:!bg-auth-soft-dark dark:hover:!text-auth-text-dark"
        @click="onBack"
      />
    </div>
    <div
      class="-ms-4 h-full overflow-y-auto border-y border-auth-border bg-auth-soft dark:border-auth-border-dark dark:bg-auth-soft-dark"
    >
      <div class="w-full h-full min-h-0">
        <IframeLoader :url="url" :is-rtl="isRTL" is-dir-applied />
      </div>
    </div>

    <div class="flex justify-end gap-2 py-2">
      <Button
        faded
        slate
        sm
        type="reset"
        icon="i-lucide-chevron-left"
        :label="$t('HELP_CENTER.ARTICLE_SEARCH.BACK')"
        class="!rounded-xl !border-auth-border !bg-auth-soft !text-auth-text hover:!bg-auth-border dark:!border-auth-border-dark dark:!bg-auth-soft-dark dark:!text-auth-text-dark dark:hover:!bg-auth-border-dark"
        @click="onBack"
      />
      <Button
        sm
        type="submit"
        icon="i-lucide-arrow-down-to-dot"
        :label="$t('HELP_CENTER.ARTICLE_SEARCH.INSERT_ARTICLE')"
        class="!rounded-xl !bg-auth-action !text-white hover:!bg-auth-action-hover dark:!bg-auth-accent dark:!text-auth-brand dark:hover:!bg-auth-accent-hover"
        @click="onInsert"
      />
    </div>
  </div>
</template>
